export default "https://cdn-static.gokick.com/assets/d7539373fb86e46f3eed15b4b495ca9c5158faa3/images/one-pack.d480e98fa5cc774d464fa35a18a8809f.png";